import { useTranslation } from 'react-i18next';

interface DestinationStepProps {
  selected: string[];
  onToggle: (dest: string) => void;
  isManga: boolean;
  isUkiyo: boolean;
}

const destinations: { name: string; kanji: string }[] = [
  { name: 'Tokyo', kanji: '東京' },
  { name: 'Kyoto', kanji: '京都' },
  { name: 'Osaka', kanji: '大阪' },
  { name: 'Nara', kanji: '奈良' },
  { name: 'Hokkaido', kanji: '北海道' },
  { name: 'Tohoku', kanji: '東北' },
  { name: 'Kanto', kanji: '関東' },
  { name: 'Chubu', kanji: '中部' },
  { name: 'Kansai', kanji: '関西' },
  { name: 'Hiroshima', kanji: '広島' },
  { name: 'Chugoku', kanji: '中国' },
  { name: 'Shikoku', kanji: '四国' },
  { name: 'Kyushu', kanji: '九州' },
  { name: 'Okinawa', kanji: '沖縄' },
  { name: 'Multiple', kanji: '複数' },
  { name: 'Not sure yet', kanji: '未定' },
];

export function DestinationStep({ selected, onToggle, isManga, isUkiyo }: DestinationStepProps) {
  const { t } = useTranslation('pages');
  // Translation only for the two meta-options. City names stay literal —
  // the internal value sent to onToggle is also the English string so
  // existing checks against 'Multiple' / 'Not sure yet' keep working.
  const labelFor = (name: string): string => {
    if (name === 'Multiple') return t('destinationStep.multiple');
    if (name === 'Not sure yet') return t('destinationStep.notSureYet');
    return name;
  };
  return (
    <div className="grid grid-cols-3 md:grid-cols-4 gap-2.5">
      {destinations.map(dest => {
        const isSelected = selected.includes(dest.name);

        const mangaStyle = isManga ? {
          background: isSelected ? '#0a0a0a' : '#fff',
          color: isSelected ? '#fff' : '#0a0a0a',
          border: '2px solid #0a0a0a',
          borderRadius: 0,
        } : undefined;

        const ukiyoStyle = isUkiyo ? {
          background: isSelected ? '#1B5C8A' : '#F5EFE0',
          color: isSelected ? '#fff' : '#1A1410',
          border: isSelected ? '2px solid #0D3A6B' : '1px solid rgba(27,79,138,0.28)',
          borderRadius: 2,
        } : undefined;

        const baseClasses = !isManga && !isUkiyo
          ? `px-3 py-2.5 rounded-xl text-center cursor-pointer transition-all duration-200 ${
              isSelected
                ? 'bg-primary-700 text-white border border-primary-700'
                : 'bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 text-gray-900 dark:text-gray-100'
            }`
          : 'px-3 py-2.5 text-center cursor-pointer transition-all duration-200';

        return (
          <button
            key={dest.name}
            type="button"
            onClick={() => onToggle(dest.name)}
            className={baseClasses}
            style={mangaStyle || ukiyoStyle || undefined}
          >
            <span className="block text-sm font-medium">{labelFor(dest.name)}</span>
            <span className="block opacity-50" style={{
              fontFamily: "'Noto Serif JP', serif", fontSize: 10,
            }}>
              {dest.kanji}
            </span>
          </button>
        );
      })}
    </div>
  );
}
